import { ProductPricingOptionDTO } from '@iota/iota-management-portal-v4-client';
import { isNotNullOrUndefined, isValidString } from '../utils';

export enum PricingOptionValueType {
    NUMBER = 1,
    DATE = 2,
    TEXT = 3
}

export function getValueType(pricingOption: ProductPricingOptionDTO): PricingOptionValueType {
    if (isNotNullOrUndefined(pricingOption?.optionDateValue)) return PricingOptionValueType.DATE;
    if (isValidString(pricingOption?.optionTextValue)) return PricingOptionValueType.TEXT;
    return PricingOptionValueType.NUMBER;
}
